export const ENGLISH = {
  question: 'What is your weight ?',
  btn_leger_text: 'Light',
  leger_info_content: `Light physiological disorders: Light sleep, search for well-being, muscle relaxation, heavy digestion.
  Light psychological disorders: Need for relaxation, need for concentration.`,
  btn_moyen_text: 'Mild',
  moyen_info_content: `Mild physiological disorders: Quality sleep, aches and pains, mild muscle pain, inflammation, digestive problems.
  Mild psychological disorders: Anxiety, stress, difficulty concentrating.`,
  btn_intensity_text: 'Intense',
  intensity_info_content: `Physiological disorders: Sleep problems, intense aches and pains, muscle and joint pain, epilepsy and degenerative diseases, menstrual pain, anorexia.
  Psychological disorders: Anxiety, stress, concentration problems
  `,
  important_text:
    'This test is a tip for calculating the recommended CBD dosage. It does not in any way constitute medical advice or a prescription.',
  powered_text: 'Questions ? we are here to help',
  btn_calcul_text: 'Calculate',
  btn_reset_text: 'Reset',
  get_calculator_text: 'Take this calculator',
  btn_copy_text: 'Copy',
  weight: 'Weight',
  trouble: 'Trouble',
  recommendation_text:
    'Recommendation in number of drops according to the concentration in% of the oil purchased.',
  gout_of_day: 'Drops per day',
  delaide_text: 'Bottle duration in days',
  oil: 'Oil',
  btn_recalculate_text: 'Calculate again',
  important: 'Important',
  effet_question: 'What effect are you looking for?',
  text_alert: `CBD oil is not intended for medical use and should not be used for the purpose of screening, diagnosing, treating, curing, mitigating, preventing, managing or monitoring disease.
  Dietary supplements and CBD oil are not a substitute for a varied and balanced diet and a healthy lifestyle.`,
  back_to_shop: 'Back to the shop',
  leger: 'Light',
  moyen: 'Mild',
  intense: 'Intense',
};
